import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { UserAuth, UserService } from '@nrwl/common-lib';

export class ProfileSettingsUpdater {
  private readonly updateUnsubscribe: Subject<void> = new Subject();
  currentUser: any;  //eslint-disable-line

  constructor(
    readonly userService: UserService,
    readonly activatedRoute: ActivatedRoute,
    readonly userAuth: UserAuth
  ) {
    this.currentUser = this.userAuth.getUserAuth();
  }

  updateUserAlertsPreferences(requestData: any): void { //eslint-disable-line
    const currentUser = this.getQueryUserName();
    this.userService.updateUserEmailNotification(currentUser, requestData)
      .pipe(takeUntil(this.updateUnsubscribe))
      .subscribe();
  }

  getQueryUserName(): any { //eslint-disable-line
    const routeUserName = this.activatedRoute.snapshot.params['userName'];
    const selectedUserName = routeUserName ? routeUserName : this.currentUser.data.USER_ID;
    return selectedUserName;
  }

  unsubscribeUpdates(): void {
    this.updateUnsubscribe.next();
    this.updateUnsubscribe.complete();
  }

}
